import script from "./ConsentDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentDetails.vue?vue&type=script&setup=true&lang=js"

import "./ConsentDetails.vue?vue&type=style&index=0&id=93e7f264&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93e7f264"]])

export default __exports__